import { FILE_TYPE_OPTION, FileTypeOption } from './FileTypeSettingsV2.constants';

const CONTENT_TYPES: Record<FileTypeOption, string[]> = {
	[FILE_TYPE_OPTION.HTML]: ['text/html', 'text/plain'],
	[FILE_TYPE_OPTION.PDF]: ['application/pdf']
};

export const toContentTypes = (option: FileTypeOption): string[] => CONTENT_TYPES[option];
